module.exports = __webpack_public_path__ + "img/home_main_image.3f3dbf79.png";